module.exports = __webpack_public_path__ + "img/2.f1a72c64.png";